import { render, staticRenderFns } from "./RecipeManage.vue?vue&type=template&id=f7e65616&scoped=true"
import script from "./RecipeManage.vue?vue&type=script&lang=js"
export * from "./RecipeManage.vue?vue&type=script&lang=js"
import style0 from "./RecipeManage.vue?vue&type=style&index=0&id=f7e65616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e65616",
  null
  
)

export default component.exports